import { RefrigeratedType } from "@assets/constants";
import { CargoPackageParentType, Commodity } from "@assets/types";

export const getTotalVolume = (
  qty: number,
  length: number,
  width: number,
  height: number
) => {
  return qty && length && width && height
    ? (qty * length * width * height) / 1000000
    : null;
};

export const getTotalWeight = (qty: number, weight: number) => {
  return qty && weight ? qty * weight : null;
};

export const isPackageRefrigerated = <
  TPackageType extends CargoPackageParentType
>(
  packageType: TPackageType | null
) => {
  if (packageType) {
    return packageType.Refrigerated === RefrigeratedType.Y ? true : false;
  }
  return false;
};

export const isCommodityTemperatureControlled = (commodity: Commodity) => {
  return (
    commodity &&
    commodity.LowerTemperature !== null &&
    commodity.HigherTemperature !== null
  );
};
